export const EMAIL_RSS_TEXT = {
  success: 'Спасибо! Ожидайте письмо с промокодом на почту',
  placeholder: 'Оставьте свой E-mail и получите купон на скидку 5%',
};

export const EMAIL_RSS_ICONS = {
  success: 'checkmark',
  default: 'arrowRight',
};
